"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faStar } from "@fortawesome/free-regular-svg-icons";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useWaveRankReward } from "@/hooks/waves/useWaveRankReward";
interface WaveSmallLeaderboardItemOutcomesProps {
  readonly drop: ApiDrop;
  readonly isMobile?: boolean | undefined;
}
export const WaveSmallLeaderboardItemOutcomes: React.FC<WaveSmallLeaderboardItemOutcomesProps> = t0 => {
  const $ = _c(50);
  const {
    drop,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const [isTouch, setIsTouch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsTouch("ontouchstart" in window);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== isOpen || $[3] !== isTouch) {
    t4 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[2] = isOpen;
    $[3] = isTouch;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClick = t4;
  let t5;
  if ($[5] !== drop.rank || $[6] !== drop.wave.id) {
    t5 = {
      waveId: drop.wave.id,
      rank: drop.rank
    };
    $[5] = drop.rank;
    $[6] = drop.wave.id;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    nicTotal,
    repTotal,
    manualOutcomes,
    isLoading
  } = useWaveRankReward(t5);
  const totalOutcomes = (nicTotal ? 1 : 0) + (repTotal ? 1 : 0) + manualOutcomes.length;
  if (totalOutcomes === 0 && !isLoading) {
    return null;
  }
  if (isLoading) {
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-animate-pulse tw-h-6 tw-w-16 tw-bg-iron-800 tw-rounded-lg" />;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== nicTotal) {
    t7 = !!nicTotal && <div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faAddressCard} className="tw-size-4 tw-text-blue-300/70" /><span className="tw-text-xs tw-font-medium tw-text-iron-300">NIC</span></div><span className="tw-text-xs tw-font-medium tw-text-blue-200/90">{nicTotal}</span></div>;
    $[10] = nicTotal;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== repTotal) {
    t8 = !!repTotal && <div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faStar} className="tw-size-4 tw-text-purple-300/70" /><span className="tw-text-xs tw-font-medium tw-text-iron-300">Rep</span></div><span className="tw-text-xs tw-font-medium tw-text-purple-200/90">{repTotal}</span></div>;
    $[12] = repTotal;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== manualOutcomes) {
    t9 = manualOutcomes.map(_temp);
    $[14] = manualOutcomes;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className="tw-p-3 tw-space-y-3 tw-min-w-[200px]"><div className="tw-space-y-2">{t6}<div className="tw-space-y-1.5">{t7}{t8}{t9}</div></div></div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const tooltipContent = t10;
  const t11 = `tw-border-0 tw-rounded-lg tw-flex tw-items-center ${isMobile ? "tw-gap-4" : "tw-gap-2"} tw-min-w-6 tw-py-1.5 tw-px-2 tw-bg-iron-800 tw-ring-1 tw-ring-iron-700 ${isTouch ? "tw-cursor-pointer" : ""}`;
  const t12 = `wave-outcomes-${drop.id}`;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="tw-text-xs tw-font-medium tw-text-iron-200">Outcome:</span>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== nicTotal) {
    t14 = !!nicTotal && <FontAwesomeIcon icon={faAddressCard} className="tw-size-4 tw-text-blue-300/70 tw-flex-shrink-0" />;
    $[21] = nicTotal;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== repTotal) {
    t15 = !!repTotal && <FontAwesomeIcon icon={faStar} className="tw-size-4 tw-text-purple-300/70 tw-flex-shrink-0" />;
    $[23] = repTotal;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== manualOutcomes.length) {
    t16 = manualOutcomes.length > 0 && <FontAwesomeIcon icon={faAward} className="tw-size-4 tw-text-amber-300/70 tw-flex-shrink-0" />;
    $[25] = manualOutcomes.length;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t15 || $[29] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-2">{t14}{t15}{t16}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== handleClick || $[32] !== t11 || $[33] !== t12 || $[34] !== t17) {
    t18 = <button onClick={handleClick} className={t11} data-tooltip-id={t12}>{t13}{t17}</button>;
    $[31] = handleClick;
    $[32] = t11;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = `wave-outcomes-${drop.id}`;
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  let t22;
  let t23;
  if ($[37] !== isTouch) {
    t21 = isTouch ? {
      click: true
    } : {
      mouseenter: true
    };
    t22 = isTouch ? {
      click: true
    } : {
      mouseleave: true
    };
    t23 = isTouch ? {
      clickOutsideAnchor: true
    } : {};
    $[37] = isTouch;
    $[38] = t21;
    $[39] = t22;
    $[40] = t23;
  } else {
    t21 = $[38];
    t22 = $[39];
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t19 || $[42] !== t21 || $[43] !== t22 || $[44] !== t23 || $[45] !== tooltipContent) {
    t24 = <Tooltip id={t19} place="top" style={t20} clickable={true} openEvents={t21} closeEvents={t22} globalCloseEvents={t23}>{tooltipContent}</Tooltip>;
    $[41] = t19;
    $[42] = t21;
    $[43] = t22;
    $[44] = t23;
    $[45] = tooltipContent;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t18 || $[48] !== t24) {
    t25 = <>{t18}{t24}</>;
    $[47] = t18;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  return t25;
};
function _temp(outcome) {
  return <div key={outcome} className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faAward} className="tw-size-4 tw-text-amber-300/70" /><span className="tw-text-xs tw-font-medium tw-text-amber-100/90">{outcome}</span></div></div>;
}